<div class="section-divider d-flex align-items-center gap-3 my-3">
  <div class="flex-grow-1 border-top"></div>
  <span class="fw-semibold small text-uppercase text-muted px-1" style="letter-spacing:.08em;">{{ 'STATISTIK_30_TAGE' | translate }}</span>
  <div class="flex-grow-1 border-top"></div>
</div>

<!-- ── Gesamtauswertung ── -->
<div *ngIf="stats.length > 0" class="mb-3">

  <!-- Jahres-Subtabs -->
  <div class="d-flex flex-wrap gap-1 mb-2">
    <button class="btn btn-sm" [ngClass]="globalYearFilter === 'all' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="setGlobalYear('all')">{{ 'GLOBAL_GESAMT' | translate }}</button>
    <button *ngFor="let y of globalStatYears" class="btn btn-sm" [ngClass]="globalYearFilter === y ? 'btn-secondary' : 'btn-outline-secondary'" (click)="setGlobalYear(y)">{{ y }}</button>
  </div>

  <div *ngIf="globalStats as g">

    <!-- Zeitraum -->
    <div class="text-center text-muted mb-2" style="font-size:.7rem;">
      <ng-container *ngIf="globalYearFilter === 'all'">{{ 'GLOBAL_DATEN_SEIT' | translate:{date: (g.since | date:'dd.MM.yyyy'), days: g.days} }}</ng-container>
      <ng-container *ngIf="globalYearFilter !== 'all'">{{ globalYearFilter }} · {{ g.since | date:'dd.MM.yyyy' }} – {{ g.until | date:'dd.MM.yyyy' }} · {{ g.days }} {{ 'AKKU_TAGE' | translate }}</ng-container>
    </div>

    <!-- Zeile 1: Energie -->
    <div class="row g-2 mb-2">
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100 border-warning">
          <div class="card-body p-2 text-center">
            <div class="text-warning" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">☀️ {{ 'GLOBAL_ERZEUGT' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.gen / 1000).toFixed(1) }}</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_MWH_GESAMT' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100 border-primary">
          <div class="card-body p-2 text-center">
            <div class="text-primary" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">🏠 {{ 'GLOBAL_VERBRAUCHT' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.cons / 1000).toFixed(1) }}</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_MWH_GESAMT' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100"
             [class.border-success]="g.autarkie >= 80"
             [class.border-warning]="g.autarkie >= 50 && g.autarkie < 80"
             [class.border-danger]="g.autarkie < 50">
          <div class="card-body p-2 text-center">
            <div style="font-size:.7rem;font-weight:600;text-transform:uppercase;"
                 [class.text-success]="g.autarkie >= 80"
                 [class.text-warning]="g.autarkie >= 50 && g.autarkie < 80"
                 [class.text-danger]="g.autarkie < 50">⚡ {{ 'COLS.AUTARKIE' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;"
                 [class.text-success]="g.autarkie >= 80"
                 [class.text-warning]="g.autarkie >= 50 && g.autarkie < 80"
                 [class.text-danger]="g.autarkie < 50">{{ p(g.autarkie).toFixed(0) }}%</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_EIGENVERSORGUNG' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100 border-danger">
          <div class="card-body p-2 text-center">
            <div class="text-danger" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">🔌 {{ 'NETZBEZUG' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.imp / 1000).toFixed(1) }}</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_MWH_VOM_NETZ' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100 border-success">
          <div class="card-body p-2 text-center">
            <div class="text-success" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">🌿 {{ 'GLOBAL_CO2' | translate }}</div>
            <div class="fw-bold mt-1 text-success" style="font-size:1.3rem;">{{ p(g.co2Saved).toFixed(2) }}</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_TONNEN_CO2' | translate }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Zeile 2: Finanzen -->
    <div class="row g-2 mb-2">
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100">
          <div class="card-body p-2 text-center">
            <div class="text-info" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">💰 {{ 'GLOBAL_STROM_GESPART' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.savings).toFixed(0) }} €</div>
            <div class="text-muted" style="font-size:.7rem;">{{ ELECTRICITY_PRICE.toFixed(2) }} €/kWh</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100">
          <div class="card-body p-2 text-center">
            <div class="text-success" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">↑ {{ 'GLOBAL_EINSPEISUNG' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.feedinRevenue).toFixed(0) }} €</div>
            <div class="text-muted" style="font-size:.7rem;">{{ FEEDIN_TARIFF.toFixed(3) }} €/kWh · {{ p(g.exp / 1000).toFixed(1) }} MWh</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100">
          <div class="card-body p-2 text-center">
            <div class="text-muted" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">📊 {{ 'GLOBAL_GESAMTNUTZEN' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.totalBenefit).toFixed(0) }} €</div>
            <div class="text-muted" style="font-size:.7rem;">≈ {{ p(g.annualBenefit).toFixed(0) }} €/{{ 'GLOBAL_JAHR' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100">
          <div class="card-body p-2 text-center">
            <div class="text-muted" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">↑ {{ 'GLOBAL_EINGESPEIST' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.exp / 1000).toFixed(1) }}</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_MWH_INS_NETZ' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100">
          <div class="card-body p-2 text-center">
            <div class="text-muted" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">⚡ {{ 'GLOBAL_EIGENVERBRAUCH' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.selfConsumed / 1000).toFixed(1) }}</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_MWH_SELBST' | translate }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Amortisation (nur All-Time) -->
    <div *ngIf="globalYearFilter === 'all'" class="card mb-2">
      <div class="card-body p-2 p-sm-3">
        <div class="d-flex justify-content-between align-items-start mb-2">
          <div class="text-muted" style="font-size:.75rem;font-weight:600;text-transform:uppercase;">🏗️ {{ 'GLOBAL_AMORTISATION' | translate }}</div>
          <div class="text-end">
            <span class="fw-bold">{{ (g.amortisation ?? 0).toFixed(1) }}%</span>
            <span class="text-muted small ms-1">{{ 'GLOBAL_VON' | translate:{eur: SYSTEM_COST_EUR.toLocaleString('de-DE')} }}</span>
          </div>
        </div>
        <div class="progress" style="height:12px;border-radius:6px;">
          <div class="progress-bar"
               [class.bg-danger]="(g.amortisation ?? 0) < 30"
               [class.bg-warning]="(g.amortisation ?? 0) >= 30 && (g.amortisation ?? 0) < 70"
               [class.bg-success]="(g.amortisation ?? 0) >= 70"
               role="progressbar"
               [style.width.%]="(g.amortisation ?? 0) > 100 ? 100 : (g.amortisation ?? 0)">
          </div>
        </div>
        <div class="d-flex justify-content-between mt-1">
          <span class="text-muted" style="font-size:.7rem;">{{ p(g.totalBenefit).toFixed(0) }} € {{ 'GLOBAL_VON' | translate:{eur: SYSTEM_COST_EUR.toLocaleString('de-DE')} }}</span>
          <span *ngIf="g.paybackYears !== null" class="text-muted" style="font-size:.7rem;">
            ≈ {{ (g.paybackYears ?? 0).toFixed(1) }} {{ 'GLOBAL_JAHRE_BREAK_EVEN' | translate }}
          </span>
        </div>
      </div>
    </div>

    <!-- Annahmen -->
    <div class="text-muted text-center mt-1 mb-2" style="font-size:.65rem;">
      {{ 'GLOBAL_ANNAHMEN' | translate:{preis: ELECTRICITY_PRICE.toFixed(2), tarif: FEEDIN_TARIFF.toFixed(3), co2: CO2_FACTOR.toFixed(3)} }}
    </div>

  </div>
</div>

<!-- ── Verlauf ── -->
<div *ngIf="stats.length > 0">
  <div class="section-divider d-flex align-items-center gap-3 mb-2">
    <div class="flex-grow-1 border-top" style="border-color:var(--bs-border-color-translucent)!important;"></div>
    <span class="small text-muted px-1">{{ 'GLOBAL_VERLAUF' | translate }}</span>
    <div class="flex-grow-1 border-top" style="border-color:var(--bs-border-color-translucent)!important;"></div>
  </div>
  <div class="d-flex align-items-center gap-2 mb-2">
    <div *ngIf="statsView === 'daily'" class="d-flex flex-wrap gap-1">
      <button class="btn btn-sm" [ngClass]="statsMonthFilter === 'all' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="statsMonthFilter = 'all'">{{ 'ALLE' | translate }}</button>
      <button *ngFor="let m of statsMonths" class="btn btn-sm" [ngClass]="statsMonthFilter === m ? 'btn-secondary' : 'btn-outline-secondary'" (click)="statsMonthFilter = m"><span class="d-none d-sm-inline">{{ fmtMonth(m) }}</span><span class="d-sm-none">{{ fmtMonthShort(m) }}</span></button>
    </div>
    <div class="ms-auto btn-group btn-group-sm">
      <button class="btn" [ngClass]="statsView === 'daily' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="statsView = 'daily'">{{ 'GLOBAL_TAEGLICH' | translate }}</button>
      <button class="btn" [ngClass]="statsView === 'monthly' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="statsView = 'monthly'">{{ 'GLOBAL_MONATLICH' | translate }}</button>
    </div>
  </div>
  <ag-grid-angular
    *ngIf="statsView === 'daily'"
    [class]="darkMode ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'"
    [style.height.px]="statsGridHeight(filteredStats.length)"
    [rowData]="filteredStats"
    [columnDefs]="statsColDefs"
    [gridOptions]="statsGridOptions">
  </ag-grid-angular>
  <ag-grid-angular
    *ngIf="statsView === 'monthly'"
    [class]="darkMode ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'"
    [style.height.px]="statsGridHeight(monthlyStats.length)"
    [rowData]="monthlyStats"
    [columnDefs]="monthlyStatsColDefs"
    [gridOptions]="statsGridOptions">
  </ag-grid-angular>
</div>
<div *ngIf="stats.length === 0" class="text-muted small text-center py-2">{{ 'KEINE_DATEN' | translate }}</div>
